import React from 'react';

const PhoneNumberText: React.FC<Props> = ({
  phoneNumber,
  showCountryCode,
}) => {
  const curPhoneNumber = phoneNumber.startsWith('61') ? `0${phoneNumber.substring(2)}` : `0${phoneNumber}`;
  return (
    <>
      {showCountryCode ? '+61 ' : ''}{curPhoneNumber.substring(showCountryCode ? 1 : 0, 4)} {curPhoneNumber.substring(4, 7)} {curPhoneNumber.substring(7, 10)}
    </>
  );
};

export interface Props {
  phoneNumber: string;
  showCountryCode?: boolean;
}

export default PhoneNumberText;
